import { useQuery } from "@tanstack/react-query";
import { getHomeIpSelect } from "src/api/home";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
const QUERY_KEYS = {
    HOME_IP_SELECT: "homeIpSelect"
};
/**
 * IP Select 섹션의 하위 데이터 조회 훅
 *
 * sourceId로 교재별 brandRanking, handoutCuration, newHandout 데이터 조회
 * - sourceId가 있을 때만 API 호출 (enabled 조건)
 * - keepPreviousData로 교재 변경 시 깜빡임 방지
 *
 * @example
 * ```tsx
 * const { data, isLoading } = useGetHomeIpSelect({
 *   sourceId: selectedBook.sourceId,
 *   sourceType: selectedBook.sourceType,
 * })
 *
 * // data.brandRanking, data.handoutCuration, data.newHandout 사용
 * ```
 */ const useGetHomeIpSelect = (options)=>{
    const { sourceId , sourceType  } = options;
    const { homeId  } = useHomeSwitchStore();
    return useQuery({
        queryKey: [
            QUERY_KEYS.HOME_IP_SELECT,
            homeId,
            sourceId
        ],
        queryFn: ()=>getHomeIpSelect({
                homeId,
                sourceId: sourceId,
                sourceType: sourceType
            }),
        enabled: !!homeId && !!sourceId && !!sourceType,
        keepPreviousData: true,
        select: (data)=>data
    });
};
export default useGetHomeIpSelect;
